import { ButtonGroup, Button } from '@flos/react-ui';
import React from 'react';
import { useHippoText } from '../hooks/useHippoText';
import GiftCertificateBanner from '../shared_components/GiftCertificate/GiftCertificate';

const WizardPagetemplate = ({
    children,
    hideNext = false,
    hidePrevious = false,
    disableNext = false,
    disablePrevious = false,
    isNextLoading = false,
    isPreviousLoading = false,
    onNext = () => {},
    onPrevious = () => {},
    continueButtonText = '',
    showGiftCertificateBanner = true,
    shouldHidePadding = false,
    shouldCenterContent = false
}: {
    hideNext?: boolean;
    hidePrevious?: boolean;
    disableNext?: boolean;
    disablePrevious?: boolean;
    isNextLoading?: boolean;
    isPreviousLoading?: boolean;
    onNext?: () => void;
    onPrevious?: () => void;
    continueButtonText?: string;
    shouldHidePadding?: boolean;
    shouldCenterContent?: boolean;
    children: React.ReactNode;
    showGiftCertificateBanner?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const hippoTexts = {
        continue: getHippoText('DSS-COMMON-CONTINUE'),
        back: getHippoText('DSS-COMMON-BACK')
    };

    return (
        <>
            <div
                className={
                    shouldHidePadding ? 'u-spacing-inset-none' : 'u-spacing-inset-l--stretch-max'
                }
            >
                {children}
            </div>
            {(!hideNext || !hidePrevious) && (
                <ButtonGroup className={shouldCenterContent ? 'u-flex-justify-center' : ''}>
                    {!hideNext && (
                        <Button
                            id="gw-wizard-next"
                            onClick={onNext}
                            disabled={disableNext}
                            isLoading={isNextLoading}
                        >
                            {continueButtonText || hippoTexts.continue}
                        </Button>
                    )}
                    {!hidePrevious && (
                        <Button
                            id="gw-wizard-previous"
                            onClick={onPrevious}
                            theme="ghost"
                            className={disablePrevious ? '' : 'u-color-primary-2-base'}
                            disabled={disablePrevious}
                            isLoading={isPreviousLoading}
                        >
                            {hippoTexts.back}
                        </Button>
                    )}
                </ButtonGroup>
            )}
            {showGiftCertificateBanner && <GiftCertificateBanner />}
        </>
    );
};

export default WizardPagetemplate;
